import * as React from "react";
import { Popover, Spin } from "antd";
import "./index.scss";
import { CredDefenseStatusEnum } from "src/services/Enum/credDefense/CredDefenseStatusEnum";
import ICredDefenseRequestValidation from "src/services/interfaces/prefraud/credDefense/ICredDefenseRequestValidation";
import { IPreFraudModalViewProps, IGetValidationButtonsProps } from "./PrefraudModalProps";
import { CredDefenseIcon } from '../Icons/CredDefense/CredDefenseIcon';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { useContext } from 'react';
import ICredDefense from 'src/services/interfaces/prefraud/credDefense/ICredDefense';
import { useEffect } from 'react';
import { ShowNotification } from '../ShowNotification/ShowNotification';
import { SourceSystemEnum } from 'src/services/Enum/credDefense/SourceSystemEnum';
import { CopyTextInput } from '../CopyTextInput/CopyTextInput';
import { ReprocessPreFraudButton } from './ReprocessPreFraudButton';

export const PreFraudModalView: React.FC<IPreFraudModalViewProps> = ({ tradeId }) => {

  const { credDefenseService } = useContext(ServiceContext);
  const [credDefense, setCredDefense] = React.useState<ICredDefense>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  useEffect(() => {
    if (tradeId) {
      credDefenseService.getByTradeId(tradeId).then(setCredDefense)
        .catch(() => ShowNotification.Error("Falha na consulta", "Ocorreu um erro durante a consulta. Tente novamente."));
    }
  }, []);


  return (
    <Spin spinning={isLoading}>

      <div className="fraud-modal-title">
        <span>Pré Fraude - SMS</span>
        <div className="wrap">
          <div className="span-wrap">
            <span className="value selfie-link">
              {credDefense ? (
                <>
                  {credDefense.source === SourceSystemEnum.UNICO && credDefense.status === CredDefenseStatusEnum.AWAITING &&
                    <>
                      <CredDefenseIcon credDefense={credDefense} />
                    Link:
                    <CopyTextInput
                        value={credDefense?.selfieUrl}
                      />
                    </>
                  }
                  {credDefense.status !== CredDefenseStatusEnum.AWAITING &&
                    <CredDefenseIcon credDefense={credDefense} />
                  }
                  {GetValidationButtons(CredDefenseStatusEnum[String(credDefense.status)], credDefense.messages)}
                </>
              ) : (
                  "Não existe"
                )
              }
            </span>
            <span className="value reprocess-button">
              {(!credDefense || credDefense?.status === CredDefenseStatusEnum.EXPIRED) && (
                <>
                  <ReprocessPreFraudButton onReprocessFinished={setCredDefense} currentTradeId={tradeId} setLoading={setIsLoading} />
                </>
              )
              }
            </span>
          </div>
        </div>
      </div>
    </Spin>
  )
}

const GetValidationButtons: React.FC<IGetValidationButtonsProps> = ({ status, validation }) => (
  status === CredDefenseStatusEnum.API_ERROR || status === CredDefenseStatusEnum.REVIEW_DATA ?
    (
      <div className="errors-button">
        <Popover content={GetErrorMessages(validation)}>
          <button className="view-fraud btn">Visualizar</button>
        </Popover>
      </div>
    )
    : null
)

const GetErrorMessages = (validation: ICredDefenseRequestValidation) => (
  <ul className="list-validation-errors">
    {validation.messages.map(value => (
      <li>{value}</li>
    ))}
  </ul>
)


// WEBPACK FOOTER //
// ./src/components/common/PreFraudView/PreFraudModalView.tsx